import PageContent from "./PageContent";

export default function NoDataComponent() {
  return (
    <>
      <PageContent>
        <h4>No Data. Please fetch Data</h4>
      </PageContent>
    </>
  );
}
